import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getTotalExistUsers,
  getTotalExistUsersWeek,
  getTotalExistUsersToday,
  getTotalExistUsersMonth,
} from '../../redux/actions/user';
import styles from './DashboardScreen.module.css';

const DashboardScreen = () => {
  const dispatch = useDispatch();

  const [totalUsers, setTotalUsers] = useState(null);
  const [usersToday, setUsersToday] = useState(null);
  const [usersWeek, setUsersWeek] = useState(null);
  const [usersMonth, setUsersMonth] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const total = await dispatch(getTotalExistUsers());
      const today = await dispatch(getTotalExistUsersToday());
      const week = await dispatch(getTotalExistUsersWeek());
      const month = await dispatch(getTotalExistUsersMonth(selectedMonth));

      setTotalUsers(total.data.result);
      setUsersToday(today.data.result);
      setUsersWeek(week.data.result);
      setUsersMonth(month.data.result);
    };

    fetchDashboardData();
  }, [dispatch, selectedMonth]);

  return (
    <div className={styles.dashboardContainer}>
      <h2 className={styles.header}>Tableau de Bord - Statistiques Utilisateur</h2>

      <div className="ui four statistics" style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
        <div className={styles.statisticCard}>
          <div className="ui statistic">
            <div className="value">{totalUsers ?? '...'}</div>
            <div className="label">Total Utilisateurs</div>
          </div>
        </div>

        <div className={styles.statisticCard}>
          <div className="ui statistic">
            <div className="value">{usersToday ?? '...'}</div>
            <div className="label">Aujourd'hui</div>
          </div>
        </div>

        <div className={styles.statisticCard}>
          <div className="ui statistic">
            <div className="value">{usersWeek ?? '...'}</div>
            <div className="label">Cette Semaine</div>
          </div>
        </div>

        <div className={styles.statisticCard}>
          <div className="ui statistic">
            <div className="value">{usersMonth ?? '...'}</div>
            <div className="label">Mois Sélectionné</div>
          </div>
        </div>
      </div>

      <div className={styles.monthDropdown}>
        <label style={{ fontWeight: 'bold' }}>Sélectionner un Mois</label>
        <select
          className="ui dropdown"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
          style={{ marginTop: 10 }}
        >
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              Mois {i + 1}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DashboardScreen;
